<script setup>

const props = defineProps({
    maxWidth: {
        type: String,
        default: '400px'
    },
    percent: {
        type: Number,
        required: true
    },
    color: {
      type: String,
      default: 'green'
    },
    over: {
      type: String,
      default: 'false'
    }
})


// background: repeating-linear-gradient(45deg, #36C55C, #36C55C 15px, #A6A6A7 0, #A6A6A7 30px);

</script>

<template>
    <div v-if="over == 'false'">
      <div class="progress-container" :style="[{'max-width': maxWidth}]">
        <div class="progress">
            <div class="progress-bar" :style="[{'width': `${percent}%`}, {'background': `var(--${color})`}]"></div>
        </div>
      </div> 
    </div>
    <div v-if="over != 'false'">
      <div class="progress-container">
        <div class="progress" :style="[{'background': 'repeating-linear-gradient(-45deg, #36C55C, #36C55C 5px, #1C1C1E 0, #1C1C1E 10px)'}, {'border-radius':'4px'}]">
            <div class="progress-bar" :style="[{'width': `${percent}%`}, {'background': `var(--${color})`}]"></div>
        </div>
      </div> 
    </div>
</template>



<style>
@media screen and (max-width: 1300px) {
  .progress {
	height: 5px;
	border-radius: 3px;
	background: var(--hover);
}
.progress-container {
	margin-bottom: 10px;
	overflow: hidden;
}
.progress-bar {
	/* // background: #000; */
	height: 100%;
	border-radius: 4px;
	transition: .5s;
	/* // background: var(--primary); */	
}
}
</style>
